import { createBrowserRouter } from 'react-router-dom';
import App from '../App';
import { ProtectedRoute } from './ProtectedRoute';
import SignIn from '../pages/SignIn';
import UserProfile from '../pages/UserProfile';
import UsersList from '../pages/UsersList';
import ResetPassword from '../pages/ResetPassword';
import SetNewPassword from '../pages/SetNewPassword';
import MachinesList from '../pages/MachinesList';
import Calendar from '../pages/Calendar';
import MachineProfile from '../pages/MachineProfile';
import MachinesGroup from '../pages/MachinesGroup';
import Locations from '../pages/Locations';
import MaintenanceTypes from '../pages/MaintenanceTypes';
import SpecificGroup from '../pages/SpecificGroup';
import Supplies from '../pages/Supplies';
import NotFoundPage from '../pages/NotFoundPage';
import AuditLogs from '../pages/AuditLogs';

export const buildRouter = (pca) =>
  createBrowserRouter([
    {
      element: <App pca={pca} />,
      children: [
        { path: '/sign-in', element: <SignIn /> },
        { path: '/reset-password', element: <ResetPassword /> },
        { path: '/set-new-password', element: <SetNewPassword /> },
        {
          element: <ProtectedRoute />,
          children: [
            { path: '/', element: <Calendar /> },
            { path: '/users', element: <UsersList /> },
            { path: '/machines', element: <MachinesList /> },
            { path: '/user-profile', element: <UserProfile /> },
            { path: '/machines/:id', element: <MachineProfile /> },
            { path: '/machines-groups', element: <MachinesGroup /> },
            { path: '/machines-groups/:id', element: <SpecificGroup /> },
            { path: '/locations', element: <Locations /> },
            { path: '/maintenance-types', element: <MaintenanceTypes /> },
            { path: '/supplies', element: <Supplies /> },
            { path: '/audit-logs', element: <AuditLogs /> },
            { path: '*', element: <NotFoundPage /> },
          ],
        },
      ],
    },
  ]);
